import { LanguageId } from 'lib-knowledge-delivery-common/graphql';
import { useLocation } from 'react-router-dom';

export function useLangId(): LanguageId | undefined {
  const { search } = useLocation();

  return (new URLSearchParams(search).get('langId') as LanguageId) ?? undefined;
}
